export enum Picklist {
  statusApaAps = 'status2__c',
  statusApe = 'registration_status__c',
  statusApn = 'registration_status1__c',
  cutoffCriteria = 'cutoff_criteria__c',
  decisionType = 'decision_type__c',
  programme = 'programme__c',
}
